import _toConsumableArray from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "sl-page"
};
var _hoisted_2 = {
  class: "list-title"
};
var _hoisted_3 = {
  class: "store-list"
};
var _hoisted_4 = {
  class: "list-title"
};
var _hoisted_5 = {
  class: "store-list"
};
import { ref, computed, onMounted, nextTick, watch } from "vue";
import { Search as VanSearch } from "vant";
import { useShopStoreWithOut } from "@/store/shopStore";
import { useAddressStoreWithOut } from "@/store/addressStore";
import { useUserStoreWithOut } from "@/store/userStore";
import GoogleMapHelper from "@/utils/googleMapHelper";
import { useRouter } from "@/hooks/useRouter";
// import { isOverOpenTime } from "@/utils/tools";
import { hideLoading, showLoading } from "@/utils/loadingUtil";
import { showToast } from "@/utils/toastUtil";
// import { getSupplyId } from "@/utils/authUtil";
import ShopItem from "./components/ShopItem.vue";
import { useSupplierStore } from "@/store/supplierStore";
import { OrderTypeEnum } from "@/constant/order";
import { useRoute } from "vue-router";
import { ShopOpenStatusEnum } from "@/constant/shop";
import { useElementVisibility } from "@vueuse/core";
import { useI18n } from "vue-i18n";
export default {
  __name: 'StoreList',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var route = useRoute();
    var _useRouter = useRouter(),
      routerBack = _useRouter.routerBack,
      routerPush = _useRouter.routerPush;
    var shopStore = useShopStoreWithOut();
    var addressStore = useAddressStoreWithOut();
    var userStore = useUserStoreWithOut();
    var supplierStore = useSupplierStore();
    var pageType = computed(function () {
      return userStore.getOrderType;
    }); // 分self_pick_up和self_delivery两种
    var mapHelper = ref(null);
    var selfCoordinate = ref(null); // 自身地址(self_pick_up时为所在定位,self_delivery为所选地址或搜索出来的地址)
    var searchValue = ref("");
    var pagination = ref({
      size: 10,
      current: 1
    });
    // 店铺列表
    var shopList = ref([]);
    var likeShopIdList = computed(function () {
      return userStore.getLikeShopIdList;
    });
    // 可能需要优化
    var favoriteList = computed(function () {
      return shopList.value.filter(function (shop) {
        return !!likeShopIdList.value.find(function (likeId) {
          return likeId === shop.shop_id;
        });
      });
    });
    var normalList = computed(function () {
      var list = shopList.value.filter(function (shop) {
        return !likeShopIdList.value.find(function (likeId) {
          return likeId === shop.shop_id;
        });
      });

      // return list.slice(0, Math.ceil(page.value * pageSize));
      return list;
    });
    var initAutocomplete = function initAutocomplete() {
      var mh = mapHelper.value;
      mh.initAutocomplete("place-search", {
        // componentRestrictions: {},
        fields: ["address_components", "name", "geometry"],
        strictBounds: false
      }, function (place) {
        if (!place.geometry) {
          // 没有经纬度,说明不是从autoComplete给的搜索结果列表中选择而来的,这里先直接return
          return;
        }
        selfCoordinate.value = {
          latitude: place.geometry.location.lat(),
          longitude: place.geometry.location.lng()
        };
      });
    };

    // 初始化selfCoordinate,地址搜索等东西
    var init = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var selectedAddress, coordinate, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              // pageType.value =
              //   router.currentRoute.value.query?.type === "self_delivery"
              //     ? "self_delivery"
              //     : "self_pick_up";
              showLoading();
              mapHelper.value = new GoogleMapHelper();
              if (!(pageType.value === OrderTypeEnum.SELF_DELIVERY)) {
                _context.next = 10;
                break;
              }
              // 自配送情况,需要获取默认的收货地址,
              selectedAddress = addressStore.getSelectedAddress;
              if (selectedAddress) {
                _context.next = 7;
                break;
              }
              // 无选中地址的情况(按流程应该要选择了地址才能进入本页面,理论上不应该触发本逻辑)
              showToast(t("noSelectedAddress"));
              return _context.abrupt("return");
            case 7:
              selfCoordinate.value = addressStore.getSelectedAddress.location.coordinate;
              _context.next = 15;
              break;
            case 10:
              _context.next = 12;
              return mapHelper.value.getCurrentPositionByH5();
            case 12:
              res = _context.sent;
              if (res.isOK && res.data) {
                userStore.setCoordinate(res.data);
                coordinate = userStore.getCoordinate;
              } else if (userStore.getCoordinate) {
                coordinate = userStore.getCoordinate;
              }
              if (coordinate) {
                selfCoordinate.value = {
                  latitude: coordinate.lat,
                  longitude: coordinate.lng
                };
              } else {
                showToast(t("failedToGetLocation"));
              }
              // nextTick(() => {
              //   initAutocomplete();
              // });
            case 15:
              hideLoading();
            case 16:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function init() {
        return _ref.apply(this, arguments);
      };
    }();

    // 判断店铺是否在开店(营业时间)
    var computeIsOpen = function computeIsOpen(shop) {
      // return !isOverOpenTime(shop.business_time || []);
      return shop.status === ShopOpenStatusEnum.IN_OPERATION;
    };

    // 判断店铺自提或自配送是否开启(自提情况判断自提开关,自配送情况则判断自配送开关)
    var computIsPickupOrDeliveryOpen = function computIsPickupOrDeliveryOpen(shop) {
      if (pageType.value === OrderTypeEnum.SELF_PICK_UP) {
        // 自提情况,判断自提配置的is_accept
        return shop.self_pickup_setting.is_accept;
      } else if (pageType.value === OrderTypeEnum.SELF_DELIVERY) {
        // 自配送情况,判断自配送配置的is_accept
        return shop.self_delivery_setting.is_accept;
      } else {
        //否则都算true
        return true;
      }
    };
    var allShopList = ref([]);
    // 获取店铺列表
    var getShopList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var shopListSub, shopListRaw, i, curShop, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // let params = {
              //   // supplier_id: shopStore.getSupplierId,
              //   supplier_id: getSupplyId(),
              // };
              // if (selfCoordinate.value) {
              //   params = {
              //     ...params,
              //     coordinate: selfCoordinate.value,
              //   };
              // }
              // 强制刷新supplierStore中的shopList
              // showLoading();
              // await supplierStore.setShopList();
              // hideLoading();
              // 这段是否需要归到computed中?
              shopListSub = []; // 先写入距离
              shopListRaw = supplierStore.getShopList.filter(function (shopItem) {
                var _shopItem$self_pickup, _shopItem$self_delive;
                return ((_shopItem$self_pickup = shopItem.self_pickup_setting) === null || _shopItem$self_pickup === void 0 ? void 0 : _shopItem$self_pickup.is_accept) || ((_shopItem$self_delive = shopItem.self_delivery_setting) === null || _shopItem$self_delive === void 0 ? void 0 : _shopItem$self_delive.is_accept);
              }).map(function (shopItem) {
                var result = _objectSpread({}, shopItem); // 浅复制
                if (selfCoordinate.value) {
                  //如果有自身坐标,要算到目标店铺的距离
                  var distance = mapHelper.value.computeDistanceBetween({
                    lat: selfCoordinate.value.latitude,
                    lng: selfCoordinate.value.longitude
                  }, {
                    lat: shopItem.location.coordinate.latitude,
                    lng: shopItem.location.coordinate.longitude
                  });
                  result.distance = distance;
                }
                return result;
              }) || []; // 按从近到远排
              if (selfCoordinate.value) {
                shopListRaw.sort(function (a, b) {
                  return a.distance - b.distance;
                });
              }
              // 按是否开启自提自配送排序
              shopListRaw.sort(function (a, b) {
                var aflag = computIsPickupOrDeliveryOpen(a);
                var bflag = computIsPickupOrDeliveryOpen(b);
                if (aflag && !bflag) {
                  return -1;
                } else if (bflag && !aflag) {
                  return 1;
                } else {
                  return 0;
                }
              });
              // 按是否开店排序
              shopListRaw.sort(function (a, b) {
                var aflag = computeIsOpen(a);
                var bflag = computeIsOpen(b);
                if (aflag && !bflag) {
                  return -1;
                } else if (bflag && !aflag) {
                  return 1;
                } else {
                  return 0;
                }
              });
              for (i = 0; i < shopListRaw.length; i++) {
                curShop = _objectSpread({}, shopListRaw[i]); // 浅复制
                // 先不筛选超出范围者
                // if (
                //   pageType.value === OrderTypeEnum.SELF_DELIVERY &&
                //   selfCoordinate.value &&
                //   mapHelper.value
                // ) {
                //   //如果是自配送,且判断出在配送范围之外,从本店铺开始后续都丢弃掉(接口默认按距离返回)
                //   const polygon = (curShop.self_delivery_setting?.delivery_area || []).map(
                //     (item) => {
                //       return { lat: item.latitude, lng: item.longitude };
                //     }
                //   );
                //   if (
                //     !mapHelper.value.containsLocation(
                //       {
                //         lat: selfCoordinate.value.latitude,
                //         lng: selfCoordinate.value.longitude,
                //       },
                //       polygon
                //     )
                //   ) {
                //     // 不在配送范围内,则跳过
                //     continue;
                //   }
                // }
                curShop.is_open = computeIsOpen(curShop);
                shopListSub.push(curShop);
              }
              // 筛选出搜索框的文字
              res = [].concat(shopListSub);
              if (searchValue.value) {
                res = shopListSub.filter(function (item) {
                  return item.shop_name.toLowerCase().includes(searchValue.value.toLowerCase());
                });
              }
              // 保留完整的数据
              allShopList.value = _toConsumableArray(res);
              // 裁出分页的数据
              shopList.value = res.slice(0, pagination.value.current * pagination.value.size - 1);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getShopList() {
        return _ref2.apply(this, arguments);
      };
    }();

    // 选择店铺
    var handleChooseShop = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(shop) {
        var _selectedAddress$loca, _shop$self_delivery_s, selectedAddress, coordinate, polygon, isInRange;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(pageType.value === OrderTypeEnum.SELF_PICK_UP)) {
                _context3.next = 18;
                break;
              }
              if (!route.query.toName) {
                _context3.next = 13;
                break;
              }
              if (!(shopStore.getShopId === shop.shop_id)) {
                _context3.next = 8;
                break;
              }
              _context3.next = 5;
              return shopStore.switchShop(shop);
            case 5:
              routerBack();
              _context3.next = 11;
              break;
            case 8:
              _context3.next = 10;
              return shopStore.switchShop(shop);
            case 10:
              routerPush({
                name: route.query.toName
              });
            case 11:
              _context3.next = 16;
              break;
            case 13:
              _context3.next = 15;
              return shopStore.switchShop(shop);
            case 15:
              routerBack();
            case 16:
              _context3.next = 47;
              break;
            case 18:
              if (!(pageType.value === OrderTypeEnum.SELF_DELIVERY)) {
                _context3.next = 47;
                break;
              }
              // 先校验是否在配送范围内
              selectedAddress = addressStore.getSelectedAddress;
              if (selectedAddress) {
                _context3.next = 23;
                break;
              }
              showToast(t("noSelectedAddress"));
              return _context3.abrupt("return");
            case 23:
              coordinate = (_selectedAddress$loca = selectedAddress.location) === null || _selectedAddress$loca === void 0 ? void 0 : _selectedAddress$loca.coordinate;
              if (coordinate) {
                _context3.next = 27;
                break;
              }
              showToast(t("outOfTheDeliveryRangeDesc"));
              return _context3.abrupt("return");
            case 27:
              polygon = (((_shop$self_delivery_s = shop.self_delivery_setting) === null || _shop$self_delivery_s === void 0 ? void 0 : _shop$self_delivery_s.delivery_area) || []).map(function (item) {
                return {
                  lat: item.latitude,
                  lng: item.longitude
                };
              });
              isInRange = mapHelper.value.containsLocation({
                lat: coordinate.latitude,
                lng: coordinate.longitude
              }, polygon);
              if (isInRange) {
                _context3.next = 32;
                break;
              }
              showToast(t("outOfTheDeliveryRangeDesc"));
              return _context3.abrupt("return");
            case 32:
              if (!route.query.toName) {
                _context3.next = 44;
                break;
              }
              if (!(shopStore.getShopId === shop.shop_id)) {
                _context3.next = 39;
                break;
              }
              _context3.next = 36;
              return shopStore.switchShop(shop);
            case 36:
              routerBack();
              _context3.next = 42;
              break;
            case 39:
              _context3.next = 41;
              return shopStore.switchShop(shop);
            case 41:
              routerPush({
                name: route.query.toName
              });
            case 42:
              _context3.next = 47;
              break;
            case 44:
              _context3.next = 46;
              return shopStore.switchShop(shop);
            case 46:
              routerBack();
            case 47:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function handleChooseShop(_x) {
        return _ref3.apply(this, arguments);
      };
    }();

    // 收藏
    var handleLike = function handleLike(shopId) {
      userStore.addShopIdListToLike(shopId);
    };

    // 取消收藏
    var handleCancelLike = function handleCancelLike(shopId) {
      userStore.deleteShopIdFromLike(shopId);
    };
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
      return _regeneratorRuntime().wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return init();
          case 2:
            // 获取店铺列表
            showLoading();
            _context4.next = 5;
            return supplierStore.setShopList();
          case 5:
            hideLoading();
            // 初始化分页
            pagination.value.current = 1;
            // 处理店铺数据
            getShopList();
          case 8:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })));
    watch(function () {
      return searchValue.value;
    }, function (val) {
      pagination.value.current = 1;
      getShopList();
    });
    function handleContentScroll() {
      if (pagination.value.size * pagination.value.current >= allShopList.value.length) {
        return;
      } else {
        pagination.value.current = pagination.value.current + 1;
        getShopList();
      }
    }
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('selectStore'),
        "is-yellow-bg": ""
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [pageType.value === _unref(OrderTypeEnum).SELF_PICK_UP ? (_openBlock(), _createBlock(_unref(VanSearch), {
            key: 0,
            id: "place-search",
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return searchValue.value = $event;
            }),
            placeholder: _ctx.$t('inputStoreName'),
            "left-icon": require('@/assets/images/search.svg')
          }, null, 8, ["modelValue", "placeholder", "left-icon"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("myFavoriteStores")), 1), _withDirectives(_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteList.value, function (shop) {
            return _openBlock(), _createBlock(ShopItem, {
              key: shop.shop_id,
              shop: shop,
              "is-like": true,
              class: "store-item",
              onChoose: function onChoose($event) {
                return handleChooseShop(shop);
              },
              onLike: function onLike($event) {
                return handleCancelLike(shop.shop_id);
              }
            }, null, 8, ["shop", "onChoose", "onLike"]);
          }), 128))], 512), [[_vShow, favoriteList.value.length > 0]]), _withDirectives(_createElementVNode("div", {
            class: "store-list-empty"
          }, _toDisplayString(_ctx.$t("noFavouriteStoresYet")), 513), [[_vShow, favoriteList.value.length === 0]]), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("otherStores")), 1), _withDirectives(_createElementVNode("div", _hoisted_5, [_createVNode(_component_van_list, {
            id: "content-scroll-box",
            class: "list",
            onLoad: handleContentScroll
          }, {
            default: _withCtx(function () {
              return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(normalList.value, function (shop, index) {
                return _openBlock(), _createBlock(ShopItem, {
                  key: "".concat(shop.shop_id, "_").concat(index),
                  shop: shop,
                  "is-like": false,
                  class: "store-item",
                  onChoose: function onChoose($event) {
                    return handleChooseShop(shop);
                  },
                  onLike: function onLike($event) {
                    return handleLike(shop.shop_id);
                  }
                }, null, 8, ["shop", "onChoose", "onLike"]);
              }), 128))];
            }),
            _: 1
          })], 512), [[_vShow, normalList.value.length > 0]]), _withDirectives(_createElementVNode("div", {
            class: "store-list-empty"
          }, _toDisplayString(_ctx.$t("noOtherStoresFound")), 513), [[_vShow, normalList.value.length === 0]])])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};